import { useQuery } from "react-query";
import { toast } from "react-toastify";
import {  getPendingOrders } from "api/Employee";

export const usePendingOrderRequests = () => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['pendingOrders'],
        () => {
            return getPendingOrders();
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
